import type { CreateContractPayload, CreateContractResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { mapEmptyContractDatesToNull } from '../validations';

import {
  zodCreateContractPayloadSchema,
  zodCreateContractResponseSchema,
} from './validations';

/**
 * Creates a new contract with optional line items.
 * The contract starts in DRAFT status.
 *
 * @param payload - The contract data to create.
 * @returns The created contract with its generated ID and metadata.
 * @throws Error if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/create_contract_contracts_post
 */
export const createContract = async (payload: CreateContractPayload) => {
  return await vestigasApi
    .post(ENDPOINT.CONTRACT.CREATE(), {
      json: payload,
      validate: {
        body: zodCreateContractPayloadSchema.transform(
          mapEmptyContractDatesToNull,
        ),
        response: zodCreateContractResponseSchema,
      },
    })
    .json<CreateContractResponse>();
};
